/* eslint-disable react/prop-types */
// added the above text for the sonarqube fix

import React from "react";
import { TextField, Autocomplete, createFilterOptions } from "@mui/material";

// --------------------------------------------------------------------
const filter = createFilterOptions();

// ------------------------------------------
export const geographyArr = [
  { code: "AF", name: "Africa" },
  { code: "AN", name: "Antarctica" },
  { code: "AS", name: "Asia" },
  { code: "EU", name: "Europe" },
  { code: "NA", name: "North America" },
  { code: "OC", name: "Oceania" },
  { code: "SA", name: "South America" },
];

const SearchSelectBoxWithAdd = ({
  name,
  options,
  setValue,
  defaultValue,
  value,
  innerValue,
  optionValue,
  optionSecValue,
  optionThirdValue,
  label,
  required,
  error,
  helperText,
  size,
  variant,
  inputRef,
  tabIndex,
  handleChange,
  toggleOpen,
  onInputChange,
  ...other
}) => {
  return (
    <Autocomplete
      name={name}
      options={options}
      getOptionLabel={(option) => {
        if (!option) return "";

        // Check for custom "Add" option first (has inputValue property)
        if (option.inputValue) {
          return option.contactName || option.c_contactName || "";
        }

        if (typeof option === "string") {
          return option;
        }

        // Handle innerValue cases (nested objects)
        if (innerValue) {
          if (optionThirdValue) {
            if (optionThirdValue === "lastName") {
              return `${option[optionValue]?.[optionSecValue] || ""} ${option[optionValue]?.[optionThirdValue] || ""}`;
            }
            return `${option[optionValue]?.[optionSecValue] || ""}-${option[optionValue]?.[optionThirdValue] || ""}`;
          }
          return option[optionValue]?.[optionSecValue] || "";
        }

        // Handle flat object cases
        if (option[optionValue] && option[optionSecValue]) {
          if (optionSecValue === "lastName") {
            return `${option[optionValue]} ${option[optionSecValue]}`;
          }
          return option[optionValue] + "-" + option[optionSecValue];
        }

        if (option[optionValue]) {
          return option[optionValue];
        }

        // Final fallback
        return option.contactName || option.c_contactName || "";
      }}
      defaultValue={defaultValue}
      onInputChange={onInputChange}
      value={value ?? null}
      // onChange={(event, newValue) => setValue(name, newValue)}
      onChange={(event, newValue) => {
        if (Array.isArray(newValue)) {
          // Multiple select case
          const lastSelected = newValue.at(-1);

          if (lastSelected?.inputValue) {
            // Custom "Add ..." clicked
            toggleOpen(lastSelected.inputValue);
          } else {
            // Normal selection
            setValue(name, newValue);
          }
        } else if ( newValue?.inputValue ) {
          // Single select case
            toggleOpen(newValue.inputValue);
          } else {
            setValue(name, newValue);
          }
        }
      }
      size={size}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);

        // Check if any existing option matches exactly
        const hasExactMatch = options?.some((item) => {
          if (innerValue) {
            return item?.[optionValue]?.[optionSecValue] === params.inputValue;
          }
          return item?.[optionValue] === params.inputValue;
        });

        // Add "Add new" option if no exact match found and input has value
        if (filtered.length === 0 || !hasExactMatch) {
          const computedValue = params.inputValue;
          if (computedValue.trim()) {
            filtered.push({
              inputValue: computedValue,
              contactName: `Add "${computedValue}"`,
            });
          }
        }
        return filtered;
      }}
      renderInput={(params) => {
        return (
          <TextField
            {...params}
            label={label}
            required={required}
            error={error}
            helperText={helperText}
            variant={variant}
            inputRef={inputRef}
            tabIndex={tabIndex}
            inputProps={{
              ...params.inputProps,
              tabIndex: tabIndex, // Set your desired tabIndex value here
            }}
          />
        );
      }}
      sx={{ marginTop: "1rem" }}
      {...other}
    />
  );
};

export default SearchSelectBoxWithAdd;
